// No direct PHP counterpart.
// Shared JS helper for:
// - api/fuel/app/classes/controller/api/monty/listing/add.php
// - api/fuel/app/classes/controller/api/monty/listing/columns.php
// - api/fuel/app/classes/controller/api/monty/listing/create.php
// - api/fuel/app/classes/controller/api/monty/listing/delete.php
// - api/fuel/app/classes/controller/api/monty/listing/edit.php
// - api/fuel/app/classes/controller/api/monty/listing/edition/create.php
// - api/fuel/app/classes/controller/api/monty/listing/edition/delete.php
// - api/fuel/app/classes/controller/api/monty/listing/filter.php
// - api/fuel/app/classes/controller/api/monty/listing/item/comment.php
// - api/fuel/app/classes/controller/api/monty/listing/order.php
// - api/fuel/app/classes/controller/api/monty/listing/remove.php
// - api/fuel/app/classes/controller/api/monty/listing/suggest.php
import DB from 'offline/db'
import Constants from 'offline/constants'
import Util from 'offline/util'
import Listing from 'offline/model/listing'
import ListingEdition from 'offline/model/listing/edition'
import ListingComment from 'offline/model/listing/comment'
import Group from 'offline/model/group'
import Buddies from 'offline/model/buddies'
import Game from 'offline/model/game'
import F from 'offline/filter/constants'
import { buildFilterConfig } from 'offline/api/monty'

var LIST_TYPE_AUTOMATED = 1
var LIST_TYPE_MANUAL = 2
var LIST_FREQUENCY_MONTHLY = 1
var LIST_FREQUENCY_YEARLY = 2
var LIST_FREQUENCY_ADHOC = 4

function json(data) {
	return {
		session: { offline: true },
		data: data
	}
}

export function ok(data) {
	return Promise.resolve(json(data))
}

export function persist(data) {
	return DB.save().then(function() {
		return json(data)
	})
}

export function currentUserId(params) {
	return params.sessionUserId || Number(DB.meta('sync_user_id') || 0) || 0
}

export function unauthorised() {
	return Promise.reject({ error: Constants.API_ERROR_UNAUTHORISED, offline: true })
}

export function invalid(code) {
	return Promise.reject({ error: code || Constants.API_ERROR_INVALID, offline: true })
}

export function ownerTypeFromParams(params) {
	if (params.type === 'groups') return Constants.TYPE_GROUP
	if (params.type === 'buddies') return Constants.TYPE_BUDDIES
	return Constants.TYPE_USER
}

export function loadOwnedContext(params, userId) {
	var type = ownerTypeFromParams(params)
	var ownerId = parseInt(params.id, 10) || 0

	if (type === Constants.TYPE_GROUP) {
		var group = Group.with_id(ownerId)
		if (!group || group.get_user_id() !== userId) return null
		return { type: type, owner: group }
	}

	if (type === Constants.TYPE_BUDDIES) {
		var buddies = Buddies.with_id(ownerId)
		if (!buddies || buddies.get_user_id() !== userId) return null
		return { type: type, owner: buddies }
	}

	return { type: type, owner: null }
}

export function loadOwnedListing(userId, listId) {
	var listing = Listing.with_id(parseInt(listId, 10) || 0)
	if (!listing) return null
	if (listing.get_user_id() !== userId) return null
	return listing
}

export function loadListingEdition(listing, editionId) {
	var edition = ListingEdition.with_id(parseInt(editionId, 10) || 0)
	if (!edition) return null
	if (edition.get_list_id() !== listing.get_id()) return null
	return edition
}

export function currentEdition(listing) {
	var edition = ListingEdition.record({
		where: [
			['list_id', '=', listing.get_id()],
			['list_edition_current', '=', 1]
		]
	})

	if (edition) return edition

	var editions = DB.query('SELECT list_edition_id FROM list_edition WHERE list_id = ? ORDER BY list_edition_date DESC, list_edition_id DESC LIMIT 1', [
		listing.get_id()
	])

	return editions.length ? ListingEdition.with_id(editions[0].list_edition_id) : null
}

export function parseGameIndex(value) {
	if (!value) return []
	return String(value).split(',').map(function(item) {
		return parseInt(item, 10) || 0
	}).filter(Boolean)
}

export function uniqueIndex(items) {
	var seen = {}
	var values = Array.isArray(items) ? items : [items]
	var result = []

	for (var i = 0; i < values.length; i++) {
		var value = parseInt(values[i], 10) || 0
		if (value && !seen[value]) {
			seen[value] = true
			result.push(value)
		}
	}

	return result
}

export function saveEditionGames(editionId, games) {
	var index = uniqueIndex(games)
	DB.run('UPDATE list_edition SET list_edition_index_games = ?, list_edition_count_games = ? WHERE list_edition_id = ?', [
		index.join(','),
		index.length,
		editionId
	])
}

export function recountListing(listId) {
	var countEditions = parseInt(DB.scalar('SELECT COUNT(*) FROM list_edition WHERE list_id = ?', [listId]), 10) || 0
	DB.run('UPDATE list SET list_count_editions = ? WHERE list_id = ?', [countEditions, listId])
}

export function ensureUniqueListingSlug(userId, groupId, buddiesId, name, excludeId) {
	var base = Util.slug(name) || 'list'
	var slug = base
	var index = 1
	var checking = true

	while (checking) {
		var sql = 'SELECT list_id FROM list WHERE user_id = ? AND group_id = ? AND buddies_id = ? AND list_slug = ?'
		var params = [userId, groupId, buddiesId, slug]
		if (excludeId) {
			sql += ' AND list_id <> ?'
			params.push(excludeId)
		}
		var match = DB.query(sql, params)
		if (!match.length) {
			checking = false
		} else {
			slug = base + '-' + index
			index++
		}
	}

	return slug
}

export function ensureUniqueEditionSlug(listId, slugBase, excludeId) {
	var base = slugBase || 'edition'
	var slug = base
	var index = 1
	var checking = true

	while (checking) {
		var sql = 'SELECT list_edition_id FROM list_edition WHERE list_id = ? AND list_edition_slug = ?'
		var params = [listId, slug]
		if (excludeId) {
			sql += ' AND list_edition_id <> ?'
			params.push(excludeId)
		}
		var match = DB.query(sql, params)
		if (!match.length) {
			checking = false
		} else {
			slug = base + '-' + index
			index++
		}
	}

	return slug
}

export function editionNameForListing(listing, timestamp) {
	if (listing.get_frequency() === LIST_FREQUENCY_MONTHLY) return Util.date('F Y', timestamp)
	if (listing.get_frequency() === LIST_FREQUENCY_YEARLY) return Util.date('Y', timestamp)
	return Util.date('j F Y', timestamp)
}

export function createEdition(listing, timestamp, current, indexGames) {
	var name = editionNameForListing(listing, timestamp)
	var slug = ensureUniqueEditionSlug(listing.get_id(), String(name).toLowerCase().replace(/ /g, '-'))
	var games = uniqueIndex(indexGames || [])

	if (current) {
		DB.run('UPDATE list_edition SET list_edition_current = 0 WHERE list_id = ? AND list_edition_current = 1', [
			listing.get_id()
		])
	}

	DB.run('INSERT INTO list_edition (list_id, list_edition_current, list_edition_name, list_edition_slug, list_edition_date, list_edition_date_generated, list_edition_count_games, list_edition_index_games) VALUES (?, ?, ?, ?, ?, ?, ?, ?)', [
		listing.get_id(),
		current ? 1 : 0,
		name,
		slug,
		timestamp,
		0,
		games.length,
		games.join(',')
	])

	var editionId = DB.scalar('SELECT last_insert_rowid()')
	recountListing(listing.get_id())
	return ListingEdition.with_id(editionId)
}

export function buildSuggestFilter(listing, params) {
	var filter = params.filter || {}
	if (filter.text && (!filter.source || (!filter.source.collection && !filter.source.ratings && !filter.source.plays))) {
		var text = String(filter.text).toLowerCase().replace(/'/g, "''")
		var rows = DB.query("SELECT game_id, game_name FROM game WHERE LOWER(game_sortname) LIKE '%" + text + "%' ORDER BY game_sortname ASC LIMIT 100")
		return rows.map(function(row) { return parseInt(row.game_id, 10) || 0 }).filter(Boolean)
	}

	var config = buildFilterConfig(params, listing.get_group_id() ? F.OWNER_GROUP : (listing.get_buddies_id() ? F.OWNER_BUDDIES : F.OWNER_USER))
	if (!config) return []

	var search = F.search(
		F.TYPE_GAMES,
		config.owner,
		filter
	)

	return search.run().index()
}

export function commentPayload(text) {
	return ListingComment.forge({
		list_comment_text: text
	}).to_array()
}

export function gameSummary(id) {
	var game = Game.with_id(id)
	if (!game) return null
	return {
		id: game.get_id(),
		name: game.get_name()
	}
}

export {
	LIST_TYPE_AUTOMATED,
	LIST_TYPE_MANUAL,
	LIST_FREQUENCY_ADHOC
}
